module.exports = __webpack_public_path__ + "assets/img/video2.72edcb86.png";